import { Box, Text } from '@nimbus-ds/components';
import { OnboardingTask } from '@tiendanube/common';
import { useNavegate } from 'App/hooks';
import { trackingRecommendationClick } from 'App/tracking';
import { useModal } from 'commons/hooks';
import { openWindow } from 'commons/utils/window';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import dashboardService from 'domains/Dashboard/services';
import { HelpOnlineStoreModal } from './components';
import OnboardingPromoteTasks from '../OnboardingPromoteTasks';

interface RecommendationsListProps {
  tasks: OnboardingTask[];
}

export function RecommendationsList({ tasks }: RecommendationsListProps) {
  const t = useTranslationDashboard();
  const { goTo } = useNavegate();
  const [isModalOpen, openModal, closeModal] = useModal(false);

  if (tasks.length === 0) return null;

  const handleConnect = async (task: OnboardingTask) => {
    trackingRecommendationClick(task.name);

    if (task.name === 'online_store_config') {
      openModal();
      return;
    }
    if (task?.onCtaLinkClickComplete) {
      await dashboardService.updateOnboardingTaskStatus({
        task: task.name,
        status: 'completed',
      });
    }
    if (task.ctaExternal) {
      openWindow(task.ctaLink, true);
    } else {
      goTo(task.ctaLink);
    }
  };

  return (
    <>
      <Box display="flex" flexDirection="column" gap="4">
        <Text fontSize="highlight" color="neutral-textHigh">
          {t('promote.recommendations')}
        </Text>
        <OnboardingPromoteTasks
          tasks={tasks}
          onAction={handleConnect}
          type="recommendation"
        />
      </Box>
      <HelpOnlineStoreModal open={isModalOpen} onDismiss={closeModal} />
    </>
  );
}

export default RecommendationsList;
